export enum Mode {
    Initial = 'initial',
    Completed = 'completed',
    PreviewGeneration = 'previewGeneration',
    DataLoaded = 'dataLoaded',
    HasError = 'hasError',
    ErrorCorrected = 'errorCorrected',
    DataSavedToMaster = 'dataSavedToMaster'
}

export enum VideoLinkField {
    VideoId = 'videoId',
    Title = 'title',
    Status = 'status',
    AccountId = 'accountId',
    VideoType = 'videoType',
    VideoTypeId = 'videoTypeId'
}

export enum VideoLinkStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}

export enum VideoLinkType {
    Launch_Intro_Video = 'Launch Intro Video',
    Watch_Tutorial = 'Watch Tutorial'
}

export enum ConfigurationTypes {
    FrequentlyUsed = 1,
    StaticIndicator,
    GeographyOverview,
    KeyIndicator,
    TrendingData,
    WhatsNew,
    IndicatorSources
}

export enum WhatsNewLinkType {
    Video = 1,
    Indicator,
    ArticleLink,
    ApplicationLink,
    Image
}

export enum WhatsNewLinkFieldType {
    Video = 'video',
    Indicator = 'indicator',
    Article = 'articleLink',
    Application = 'applicationLink',
    Image = 'image'
}

export enum IndicatorSourceField {
    SourceName = 'sourceName',
    WebAddress = 'webAddress'
}

export enum ConfirmationAction {
    OK = 1,
    CANCEL
}
